export default "__VITE_ASSET__b6a20fef__"